import type {Schemas} from 'domainTypes/dto';
import {ebsApi} from 'store/ebsApi';
import {
  type BulkUpdate,
  type BulkUpdateCreate,
  type BulkUpdateCreateResponse,
  type BulkUpdateList,
} from './types';
import {mapBulkUpdateSummaryDto, mapToBulkUpdateWorkRequest} from './mappers';

const bulkUpdatesApi = ebsApi.injectEndpoints({
  endpoints: build => ({
    getBulkUpdate: build.query<
      Schemas.BulkUpdateStatusResponse,
      Pick<BulkUpdate, 'id'>,
      Schemas.BulkUpdateStatusResponse
    >({
      keepUnusedDataFor: 60,
      query: ({id}) => ({
        url: `bulkupdate/${id}`,
      }),
    }),
    getBulkUpdates: build.query<
      BulkUpdateList,
      {page: number; size: number},
      Schemas.AllBulkUpdatesPageResponse
    >({
      keepUnusedDataFor: 10,
      query: params => ({
        url: 'bulkupdate',
        params: {
          ...params,
          sort: 'created,desc',
        },
      }),
      transformResponse(response) {
        return {
          pages: response.totalPages ?? 0,
          elements: response.totalElements ?? 0,
          items: (response.items ?? []).map(mapBulkUpdateSummaryDto),
        };
      },
    }),
    createBulkUpdateWork: build.mutation<
      BulkUpdateCreateResponse,
      {
        bulkUpdate: BulkUpdateCreate;
        ids: string[];
      },
      Schemas.BulkUpdateWorkRequest
    >({
      query: ({bulkUpdate, ids}) => ({
        url: 'bulkupdate/work',
        method: 'POST',
        body: mapToBulkUpdateWorkRequest(bulkUpdate, ids),
      }),
    }),
  }),
});

export const {
  useGetBulkUpdateQuery,
  useGetBulkUpdatesQuery,
  useCreateBulkUpdateWorkMutation,
} = bulkUpdatesApi;
